<template>
    <div id='CollectedSkuList'>
        <div class='CollectedSku' v-for='(Collection, idx) in Collections'
            :key='idx'
            :name='Collection.name'
        >
            <a href='#' @click.prevent='selectList(Collection.name)'>
                <span>{{Collection.name}}</span>
                <span class='carat'>
                    <DownChevronIcon />
                </span>
            </a>
            <SkuList :SkuList = 'Collection.Skus' v-if='selectedName == Collection.name'> </SkuList>
        </div>

    </div>
</template>

<script>
    import SkuList from './SkuList.vue';
    import DownChevronIcon from '../../../icons/DownChevronIcon';
    export default{
        name: 'SkuCollector',
        components: {
            SkuList,
            DownChevronIcon
        },
        data(){
            return{
                Collections: [
                    {name: 'Skus Collected', Skus:['006570007012', '0000745670012','00000002012','00000030012']},
                    {name: 'Form Input', Skus:['00005678607012', '00000060012','00000002012','00000030012']},
                    {name: 'Form Input', Skus:['00000007012', '0000567540012', '00000030012']},
                    {name: 'Form Input', Skus:['000567457012', '00000060012','0000000456745612','000000304562']},
                    {name: 'Form Input', Skus:['00067540007012', '000056745670012','00004567542012','000000307652']},
                    {name: 'Form Input', Skus:['00007467007012', '00000d002012','00000030012']},
                    {name: 'Form Input', Skus:['006578600007012', '00000060012','000000752012','00000037612']}
                ],
                opened: false,
                selectedName: ''
            }
        },
        methods:{
            selectList(name){
                console.log('clicked - ' + name +', selectedName - ' +this.selectedName);
                if(this.selectedName == name){
                    this.selectedName = '';
                }else{
                    this.selectedName = name;
                }
            }
        }
    }
</script>